import Header from "@editorjs/header";
import ImageTool from "@editorjs/image";
import {getAuthToken} from "../../helpers/helperFunctions";
import List from "@editorjs/list";
import Embed from "@editorjs/embed";
import Delimiter from "@editorjs/delimiter";
// import Table from "@medistream/editorjs-table";
import Table from "@editorjs/table";
import Paragraph from '@editorjs/paragraph';
import {
  BLOG_CONTENT_KEY_DELIMITER,
  BLOG_CONTENT_KEY_EMBED, BLOG_CONTENT_KEY_FOCUS_ITEM,
  BLOG_CONTENT_KEY_HEADER,
  BLOG_CONTENT_KEY_IMAGE,
  BLOG_CONTENT_KEY_LIST, BLOG_CONTENT_KEY_PARAGRAPH, BLOG_CONTENT_KEY_TABLE
} from "./constants";
import {isValidBlogContent, isValidBlogTable, isValidWebUrl} from "../../helpers/validationHelper";
import {FocusedItemBlockTool} from "./CustomBlockTools";

export const editorJsConfig = () => {

  return {
    [BLOG_CONTENT_KEY_HEADER]: {
      class: ExtendedHeaderTool,
      config: {
        placeholder: 'Enter a header',
        levels: [2],
        defaultLevel: 2
      }
    },
    [BLOG_CONTENT_KEY_PARAGRAPH]: {
      class: ExtendedParagraphTool
    },
    [BLOG_CONTENT_KEY_IMAGE]: {
      class: ExtendedImageTool,
      inlineToolbar: false,
      config: {
        captionPlaceholder: "Image Link (leave blank to skip this)",
        uploader: {
          /**
           * Upload file to the server and return an uploaded image data
           * @param {File} file - file selected from the device or pasted by drag-n-drop
           * @return {Promise.<{success, file: {url}}>}
           */
          uploadByFile(file) {
            let formData = new FormData();
            formData.append("image", file);
            return fetch(`${process.env.REACT_APP_BACKEND_URL}/cms/banner-uploads`, {
              method: "POST",
              body: formData,
              headers: {
                'Authorization': `Bearer ${getAuthToken()?.access_token}`
              }
            }).then(response => response.json()).then((resp) => {
              return {
                success: 1,
                file: {
                  url: resp.image
                }
              };
            });
          }
        }
      }
    },
    [BLOG_CONTENT_KEY_LIST]: {
      class: List,
      inlineToolbar: true,
      config: {
        defaultStyle: 'unordered'
      }
    },
    [BLOG_CONTENT_KEY_TABLE]: {
      class: Table,
      config: {
        rows: 3,
        cols: 2,
      }
    },
    [BLOG_CONTENT_KEY_FOCUS_ITEM]: FocusedItemBlockTool,
    [BLOG_CONTENT_KEY_EMBED]: {
      class: ExtendedEmbedTool,
      config: {
        services: {
          youtube: true
        }
      }
    },
    [BLOG_CONTENT_KEY_DELIMITER]: Delimiter
  };
};

export const isBlogContentInvalid = (content) => {

  return content.type === BLOG_CONTENT_KEY_FOCUS_ITEM ? (content.data.value ? false : "Please fill in the focus item, or remove it.")

    : content.type === BLOG_CONTENT_KEY_TABLE ? (isValidBlogTable(content) ? false : "You have empty content in one or more tables.")

      : content.type === BLOG_CONTENT_KEY_HEADER || content.type === BLOG_CONTENT_KEY_PARAGRAPH ?
        (isValidBlogContent(content.data.text) ? false : "Some contents are empty.") :
        content.type === BLOG_CONTENT_KEY_IMAGE ?
          (!content.data.file?.url ? "The Image element is empty. Please upload the image or remove the element." : (content.data.caption?.trim() && !isValidWebUrl(content.data.caption.trim())) ? "Url in the images are not valid." : false)
          : false;

};

class ExtendedImageTool extends ImageTool {

  renderSettings() {
    return [];
  }

  validate(savedData) {
    // return savedData.file && savedData.file.url;
    return true;
  }

  save() {
    const caption = this.ui.nodes.caption;

    this._data = {...this._data, caption: caption.innerHTML};

    return this.data;
  }

  set image(file) {
    this._data = file ? {...this._data, file} : this._data;


    if (file && file.url) {
      this.ui.fillImage(file.url);
    }
  }
}


class ExtendedEmbedTool extends Embed {

  // get data() {
  //   if (this.element) {
  //     const t = this.element.querySelector(`.${this.api.styles.input}`);
  //     this._data = {...this._data, caption: t ? t.innerHTML : ""};
  //   }
  //   return this._data;
  // }

}

class ExtendedHeaderTool extends Header {

  validate(e) {
    // return e.text.trim() !== "";

    return isValidBlogContent(e.text);
  }

}

class ExtendedParagraphTool extends Paragraph {

  validate(e) {
    return isValidBlogContent(e.text);
  }

}


